import { marketplace } from '@sellpy/commons'
import { fromJS } from 'immutable'
import Parse from 'parse'
import { cacheEntities } from '../entities/actions'
import { runCloudCached } from '../lib/parseTools'
import { getRegion } from '../region/region'

export const getAllTransactionsForItem = (itemId) => async (dispatch) =>
  runCloudCached((transactions) => {
    dispatch(cacheEntities(transactions))
  })('getAllTransactionsForItem', { itemId })

export const getAllP2pTransactionsForItem = (itemId) => async (dispatch) =>
  runCloudCached((transactions) => {
    dispatch(cacheEntities(transactions))
  })('getAllP2pTransactionsForItem', { itemId })

export const SALE_BALANCES_FETCHED = 'SALE_BALANCES_FETCHED'

export const TOTAL_BALANCE_FETCHED = 'TOTAL_BALANCE_FETCHED'
export const getTotalBalanceForUser = () => async (dispatch) =>
  dispatch({
    type: TOTAL_BALANCE_FETCHED,
    totalBalance: fromJS(
      await Parse.Cloud.run('getTotalBalanceForUser', {
        currency: marketplace.CURRENCY[getRegion()]
      })
    )
  })

export const RESERVED_AD_FEES_FETCHED = 'RESERVED_AD_FEES_FETCHED'
